export default "__VITE_ASSET__BC8UMpZ6__"